import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './allRoutes';
import { customerRoutes } from './customerRoutes';
import Layout from 'Layout';
import CustomerLayout from 'Layout/CustomerLayout';
import NonAuthLayout from "Layout/NonLayout"
import AuthProtected from './AuthProtected';
const RouteIndex = () => {
  return (
    <React.Fragment>
      <Routes>
        {/* Customer routes - use CustomerLayout */}
        {customerRoutes.map((route: any, idx: number) => (
          <Route
            key={`customer-${idx}`}
            path={route.path}
            element={
              <AuthProtected>
                <CustomerLayout>
                  <route.component />
                </CustomerLayout>
              </AuthProtected>
            }
          />
        ))}
        {/* Admin routes - use Layout */}
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <AuthProtected>
                <Layout>
                  <route.component />
                </Layout>
              </AuthProtected>
            }
          />
        ))}
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <NonAuthLayout>
                <route.component />
              </NonAuthLayout>
            } />
        ))}
      </Routes>
    </React.Fragment>
  );
};

export default RouteIndex;
